module.exports = __webpack_public_path__ + "media/images/expert__dominik-landertinger-fcccd9b9937258a7849c20bec44d878c.png";